/* @flow */
import React from 'react';
import { observer } from 'mobx-react';
import FormHelperText from '@material-ui/core/FormHelperText';

import ElectroMessageBarCont from 'forms/components/inputs/ElectroMessageBarCont/ElectroMessageBarCont';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from './ActionDrawerWarnings.module.scss';

/*
 * ActionDrawerWarnings
 *
 * @prop {Object} field
 * @prop {Object} warnings
 * @return {React.Node}
 */
const ActionDrawerWarnings: React.StatelessFunctionalComponent<*> = ({
  field,
  warnings,
}: Object) => (
  <React.Fragment>
    {field.value &&
      warnings &&
      warnings.filter((item: Object) => {
        return field.value[item.name];
      }).length > 0 && (
        <ActionDrawerBlock gutters={true} padding={true}>
          <div className={styles['form-group']}>
            <ul>
              {warnings.map((item: Object) => {
                return field.value[item.name] ? (
                  <ElectroMessageBarCont
                    key={item.name}
                    props={{
                      linkto: item.link ? item.link : null,
                      variant: 'warning',
                      message: item.message,
                    }}
                  />
                ) : null;
              })}
            </ul>
            {field.error && field.showError && (
              <FormHelperText error={true}>{field.error}</FormHelperText>
            )}
          </div>
        </ActionDrawerBlock>
      )}
  </React.Fragment>
);

export default observer(ActionDrawerWarnings);
